const $inject = ['$rootScope', '$scope', '$routeParams', '$timeout', 'dataService'];

const lbaTextInputCtrl = function ($rootScope, $scope, $routeParams, $timeout, dataService) {
    const vm = this;
    const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

    vm.data = _.get(dataService.data.activeItem, dataLookUp);
    vm.hideIfEmpty = vm.settings.hideIfEmpty && !vm.data;// hide if hideIfEmpty flag is set and the input is empty.
    vm.inputType = vm.settings.inputType || 'text';
    vm.min = vm.settings.min || 0;
    vm.max = vm.settings.max || 10000000000;
    vm.minLength = vm.settings.minLength || 0;
    vm.maxLength = vm.settings.maxLength || 10000000000;
    vm.validationPattern = vm.settings.validationRegex;
    vm.isValid = true;
    $scope.$watch(() => dataService.data.activeItem, () => {
        vm.data = _.get(dataService.data.activeItem, dataLookUp);
    });
    $scope.$watchCollection('vm.data', (newData, oldData) => {
       
        if (vm.validationPattern) {
            let regex = new RegExp(vm.validationPattern);
            vm.isValid = regex.test(vm.data || '');
            $scope.$emit('ValidationStatusChanged', {
                controllerName: $scope.vm.settings.dataAt,
                value: newData,
                isValid: vm.isValid
            });
        }


        if (newData !== oldData) {
            _.set(dataService.data.activeItem, dataLookUp, newData)
        }
    });

    $rootScope.$on(vm.settings.dataAt, () => {
        $timeout(() => {
            vm.data = _.get(dataService.data.activeItem, dataLookUp);
            vm.hideIfEmpty = vm.settings.hideIfEmpty && !vm.data;// hide if hideIfEmpty flag is set and the input is empty.
        })
    });
};

lbaTextInputCtrl.$inject = $inject;

export default lbaTextInputCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaTextInput/lbaTextInputCtrl.js